/**
 * Ce module a été codé initialement en es5, il doit le rester
 * car il est inclus par pas mal de code qui ne passe pas forcément par babel.
 */
var maxSync = 50

/* global process, module */

/**
 * Équivalent du module npm seq pour faciliter l'écriture de flux asynchrone
 * (l'autre solution étant le chaînage de promesse, ou async/await)
 * @see https://www.npmjs.com/package/seq
 * @module flow
 * @type FlowModifier
 * @return {Flow}
 */
function flow () {
  if (arguments.length && !Array.isArray(arguments[0])) throw Error('flow ne prend qu’un array en éventuel argument')
  // on crée l'éventuelle erreur ici, pour avoir une stacktrace utilisable
  var _error = Error()
  // ce qui sera passé au 1er seq via apply
  var _initialArguments = Array.prototype.slice.call(arguments)
  // le 1er arg est l'erreur éventuelle, pas au démarrage
  _initialArguments.unshift(undefined)

  // la pile de cb du flow
  var _callbacks = []
  // la cb catch
  var _catchCallback
  // _catchCallback pourrait être appelée plusieurs fois si ça plante dans un parEach
  // (ou seqEach avec du nextTick), on ne doit pas appeler la cb plusieurs fois
  // et il faut arrêter les appels de cb au 1er plantage
  var _hasFailed = false

  // la position actuelle dans la pile de _callbacks
  var _pos

  // par défaut on démarre avec sync
  // nextTick() peut le changer ensuite, et ça passe async si seqEach|parEach reçoivent plus de 50 items
  var _processCallback = _processCallbackSync

  // émulation de process.nextTick si on est dans un navigateur
  var _nextTick = (typeof process !== 'undefined' && typeof process.nextTick === 'function')
    ? process.nextTick
    : function (fn) { setTimeout(fn, 0) }

  function _wrapError (error) {
    // on ajoute error en cause de notre _error
    if (error.cause) {
      // on n'en garde qu'une, celle d'origine
      _error.cause = error.cause
      // en cas de cause en cascade on veut une stacktrace qui cumule tout ça,
      var lines = _error.stack.split('\n').slice(2).concat((error.fullStack || error.stack).split('\n').slice(1))
      // cumul sans les lignes internes à an-flow (ça virera rien si on a été compilé / minifié
      // pour un navigateur, mais au moins pour node ce sera plus lisible)
      // (le . ne match pas \n car on a pas précisé le flag s)
      // on garde cet appel de flow() et on vire les autres
      _error.fullStack = error.message + '\n' +
        // et sur le reste on vire les lignes an-flow
        lines.join('\n').replace(/\n.+an-flow.+$/gm, '')
        // lines.filter(line => !line.includes('an-flow')).join('\n')

      // faut aussi remonter ça si ça existe
      if (error.cause.errors) _error.errors = error.cause.errors
    } else {
      _error.cause = error
      if (error.errors) _error.errors = error.errors
    }
    // l'objet error est parfois une string, il sera transformé en Error mais faut le gérer
    _error.message = error.message || String(error)
    if (!_error.message.includes('[forwarded]')) _error.message += ' [forwarded]'
    _catchCallback(_error)
  }

  /**
   * Récupère le résultat précédent et lance la cb suivante dans la pile
   * Nombre variable d'arguments (le premier est une éventuelle erreur, les suivants ceux que la cb aura passé à son this)
   * @private
   * @param {Error} error
   * @private
   */
  function _cbListener (error) {
    if (error) return _wrapError(error)
    var args = Array.prototype.slice.call(arguments, 1)
    _pos++
    var nextCb = _callbacks[_pos]
    if (nextCb) _processCallback(nextCb, args, _cbListener)
    // si y'a plus de next mais qu'on lui file des data on râle
    else if (args.length) console.error(Error('inexistent next sequence called with data'), args)
    // et sinon on dit rien (ça paraît bizarre mais on peut imaginer un dernier seqEach qui tourne en tâche de fond)
  }

  /**
   * Appelle une cb en lui passant args (et _cbListener en contexte)
   * @private
   * @param {function} callback La fct à lancer, on lui passera _cbListener en context pour qu'elle l'appelle via this()
   * @param {Array} args passés à callback (via apply)
   * @param {function} _cbListener La fct de récupération (qui gèrera l'erreur passée en 1er argument)
   * @private
   */
  function _processCallbackSync (callback, args, _cbListener) {
    // si une autre cb a déjà planté, on exécute plus rien
    if (_hasFailed) return

    try {
      callback.apply(_cbListener, args)
    } catch (error) {
      if (_hasFailed) return
      _hasFailed = true
      _wrapError(error)
    }
  }

  /**
   * Appelle une cb en lui passant args (et _cbListener en contexte)
   * @private
   * @param {function} callback La fct à lancer, on lui passera _cbListener en context pour qu'elle l'appelle via this()
   * @param {Array} args passés à callback (via apply)
   * @param {function} _cbListener La fct de récupération (qui gèrera l'erreur passée en 1er argument)
   * @private
   */
  function _processCallbackAsync (callback, args, _cbListener) {
    _nextTick(function () {
      _processCallbackSync(callback, args, _cbListener)
    })
  }

  /**
   * Clotûre le flow avec une fonction de récupération d'erreur (la première qui sera éventuellement envoyée)
   * Ça lance la série de callbacks
   * @param {FlowErrorCallback} cb
   * @name catch
   */
  function _catch (cb) { // catch est un mot réservé en js
    if (typeof cb !== 'function') throw Error('Callback needed')
    // on enregistre la cb
    _catchCallback = cb
    // passe async si y'a bcp de seq
    if (_callbacks.length > maxSync) nextTick()
    // et on lance l'exécution de la pile
    _pos = -1
    _cbListener.apply(undefined, _initialArguments)
    // on en a plus besoin, pas la peine de garder ça en ram
    _initialArguments = null
  }

  /**
   * Raccourci pour `.seq(cb).catch(cb)`
   * @param {Function} cb
   */
  function done (cb) {
    if (typeof cb !== 'function') throw Error('Callback needed')
    seq(function () {
      var args = Array.prototype.slice.call(arguments)
      args.unshift(null)
      cb.apply(undefined, args)
    })
    _catch(cb)
  }

  /**
   * Vide la pile interne (pour le seq suivant)
   * @return {Flow}
   */
  function empty () {
    _callbacks.push(function () { this() })
    return _self
  }

  /**
   * Active (ou désactive) le wrap de chaque appel de callback à venir dans un process.nextTick
   * (ou setTimeout(0) si on est dans un navigateur), utile pour éviter les dépassements de callStack
   * Activé automatiquement si la pile transmise à seqEach|parEach dépasse 50 éléments
   * @param {boolean} [setActive=true]
   * @return {Flow}
   */
  function nextTick (setActive) {
    _processCallback = setActive === false ? _processCallbackSync : _processCallbackAsync
    return _self
  }

  /**
   * Ajoute une séquence de code qui sera exécutée en parallèle sur la pile interne (comme un Promise.all)
   * Attention à ne pas l'utiliser pour lancer 1000 requêtes mongo en parallèle (ça va saturer les connexions dispo et sera plus lent ou plantera)
   * Sur du code sync préférer seqEach qui plus rapide (× 2 à 3 avec une cb simple sur de gros volumes)
   * @param {FlowItemCallback} cb Code async à exécuter, appelée avec chaque élément de la pile interne
   * @return {Flow}
   */
  function parEach (cb) {
    // On crée une cb dans le flow qui prend un tableau en entrée et va lancer cb avec chacun
    function _parEachWrapper (items) {
      if (!Array.isArray(items)) return _catchCallback(Error('Array needed for parEach'))
      stack = items
      var nbItems = items.length
      // init du tableau de résultats
      results = Array(nbItems)
      if (nbItems > maxSync) nextTick()

      // On lance l'ensemble des séquences en //
      for (var i = 0; i < nbItems; i++) {
        _processCallback(cb, [items[i], i], getCbListener(i))
      }
    }

    // le générateur des nextFn qui seront passées à _processCallback
    function getCbListener (index) {
      return function _parEachCbListener (error) {
        nbResultsReceived++
        if (error) return _wrapError(error)
        if (arguments.length < 2) results[index] = undefined
        else if (arguments.length === 2) results[index] = arguments[1]
        // sinon on converti la liste d'arguments en tableau
        else results[index] = Array.prototype.slice.call(arguments, 1)
        // Si on est le dernier on passe à la prochaine séquence
        if (nbResultsReceived === stack.length) _cbListener(null, results)
      }
    }

    if (typeof cb !== 'function') throw Error('Callback needed')
    var stack
    var results
    var nbResultsReceived = 0
    _callbacks.push(_parEachWrapper)

    return _self
  }

  /**
   * Ajoute une séquence de code
   * @param {FlowCallback} cb Code async à exécuter. Attention, pas de arrow function puisque this(error, data) sert à indiquer la fin
   * @return {Flow}
   */
  function seq (cb) {
    if (typeof cb !== 'function') throw Error('Callback needed')
    _callbacks.push(cb)
    return _self
  }

  /**
   * Ajoute une séquence de code qui sera exécutée en série sur la pile interne.
   * @param {FlowItemCallback} cb Code async à exécuter, appelée avec chaque élément de la pile interne en premier argument et son index en 2e
   * @return {Flow}
   */
  function seqEach (cb) {
    // fct qui simule un seq classique
    function _seqEachWrapper (items) {
      // check que c'est un tableau
      if (!Array.isArray(items)) return _catchCallback(Error('Array needed for seqEach'))
      stack = items
      if (items.length > maxSync) nextTick()
      pos = -1
      _processOne()
    }

    // process un item
    function _processOne () {
      // S'il on est arrivé à la fin on appelle la prochaine séquence
      if (++pos === stack.length) return _cbListener(null, results)
      // Sinon on exécute la suite de nos items
      _processCallback(cb, [stack[pos], pos], _seqEachCbListener)
    }

    // cb passée à _processCallback qui traite la réponse de _processOne
    function _seqEachCbListener (error) {
      if (error) return _wrapError(error)
      // récup des résultats
      if (arguments.length < 2) results.push(undefined)
      else if (arguments.length === 2) results.push(arguments[1])
      // sinon on converti la liste d'arguments en tableau
      else results.push(Array.prototype.slice.call(arguments, 1))
      // lancement de la callback suivante
      _processOne()
    }

    if (typeof cb !== 'function') throw Error('Callback needed')
    var stack
    var pos
    var results = []
    _callbacks.push(_seqEachWrapper)
    return _self
  }

  /**
   * Affecte la pile interne (pour le seq suivant)
   * @param {unknown} value
   * @return {Flow}
   */
  function set (value) {
    return seq(function () {
      this(null, value)
    })
  }

  // le flow créé (chaînable)
  var _self = {
    catch: _catch,
    done: done,
    empty: empty,
    fail: _catch,
    nextTick: nextTick,
    parEach: parEach,
    seq: seq,
    set: set,
    seqEach: seqEach
  }

  return _self
}

module.exports = flow
